import React from "react"
import ReactDOM from "react-dom"
import "babel-polyfill"
import "./index.css"

require("./component")
const App = require("./app").default

if (module.hot) {
  module.hot.accept()
}

ReactDOM.render(<App />, document.querySelector("d-article"))
